import Vector2 from '../math/Vector2';

export default class Touch {
	position: Vector2;
	id: number;

	constructor (id: number, position: Vector2) {
		this.position = position;
		this.id = id;
	}
}
